import { MenuItem } from "@mui/material"
import { toDataCy } from "lib/to-data-cy"

export function MyScheduleSortOption({ item: [mode, description], value, onChange }) {
    return (
        <MenuItem
            selected={mode === value}
            onClick={() => onChange(mode)}
            data-cy={toDataCy("custom-schedule-sort-option", mode)}
        >
            {description}
        </MenuItem>
    )
}
